export default {
  'pages.layouts.userLayout.title': '你好！',
  'pages.getCaptchaSecondText': '秒後重新獲取',
  'pages.workbench.link': '歡迎使用',
  'pages.workbench.alertMessage': '更快更強的重型組件，已經發布。',
  'pages.404.subTitle': '抱歉，您訪問的頁面不存在。',
  'pages.404.buttonText': '返回首頁',
  'pages.admin.subPage.title': '這個頁面只有 admin 權限才能查看',
  'pages.admin.subPage.alertMessage':
    'umi ui 現已發佈，歡迎使用 npm run ui 啓動體驗。',
  'pages.searchTable.createForm.newRule': '新建規則',
  'pages.searchTable.updateForm.ruleConfig': '規則配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '規則名稱',
  'pages.searchTable.updateForm.ruleName.nameRules': '請輸入規則名稱！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '規則描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '請輸入至少五個字符',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '請輸入至少五個字符的規則描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置規則屬性',
  'pages.searchTable.updateForm.object': '監控對象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '規則模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '規則類型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '設定調度週期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '開始時間',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '請選擇開始時間！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '規則名稱爲必填項',
  'pages.searchTable.titleCallNo': '服務調用次數',
  'pages.searchTable.titleStatus': '狀態',
  'pages.searchTable.nameStatus.default': '關閉',
  'pages.searchTable.nameStatus.running': '運行中',
  'pages.searchTable.nameStatus.online': '已上線',
  'pages.searchTable.nameStatus.abnormal': '異常',
  'pages.searchTable.titleUpdatedAt': '上次調度時間',
  'pages.searchTable.exception': '請輸入異常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '訂閱警報',
  'pages.searchTable.title': '查詢表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已選擇',
  'pages.searchTable.item': '項',
  'pages.searchTable.totalServiceCalls': '服務調用次數總計',
  'pages.searchTable.tenThousand': '萬',
  'pages.searchTable.batchDeletion': '批量刪除',
  'pages.searchTable.batchApproval': '批量審批',
  'pages.template.title': '模板示例',
  'pages.template.submit.success': '表單提交成功！',
  'pages.template.form.name': '姓名',
  'pages.template.form.email': '電子郵箱',
  'pages.template.form.department': '部門',
  'pages.template.form.joinDate': '入職日期',
  'pages.template.form.remarks': '備註',
  'pages.template.placeholder.name': '請輸入姓名',
  'pages.template.placeholder.email': '請輸入電子郵箱',
  'pages.template.placeholder.department': '請選擇部門',
  'pages.template.placeholder.remarks': '請輸入備註資訊',
  'pages.template.validation.nameRequired': '請輸入姓名',
  'pages.template.validation.emailRequired': '請輸入電子郵箱',
  'pages.template.validation.emailInvalid': '電子郵箱格式不正確',
  'pages.template.validation.departmentRequired': '請選擇部門',
  'pages.template.validation.joinDateRequired': '請選擇入職日期',
  'pages.template.department.tech': '技術部',
  'pages.template.department.sales': '銷售部',
  'pages.template.department.hr': '人力資源部',
  'pages.template.department.finance': '財務部',
  'pages.template.action.submit': '提交',
  'pages.template.action.reset': '重置',

  // 專案管理
  'pages.projects.column.name': '空間名稱',
  'pages.projects.column.description': '描述',
  'pages.projects.column.appCount': '應用數量',
  'pages.projects.column.memberCount': '成員數',
  'pages.projects.column.createdAt': '創建時間',
  'pages.projects.column.action': '操作',
  'pages.projects.action.detail': '進入空間',
  'pages.projects.action.cancel': '取消',
  'pages.projects.action.save': '保存',
  'pages.projects.action.delete': '刪除',
  'pages.projects.action.remove': '移除',
  'pages.projects.form.name': '空間名稱',
  'pages.projects.form.name.placeholder': '請輸入專案空間名稱',
  'pages.projects.form.description': '空間描述與目標',
  'pages.projects.form.description.placeholder':
    '描述該空間承載的微服務業務與團隊職責...',
  'pages.projects.create.title': '新建專案空間',
  'pages.projects.create.success': '專案空間創建成功',
  'pages.projects.tab.overview': '空間概覽',
  'pages.projects.tab.market': '應用市場',
  'pages.projects.tab.apps': '微服務應用',
  'pages.projects.tab.databases': '數據庫實例',
  'pages.projects.tab.storage': '對象存儲',
  'pages.projects.tab.members': '團隊成員',
  'pages.projects.tab.auditLog': '審計日誌',
  'pages.projects.tab.settings': '空間設置',

  // 概覽
  'pages.projects.overview.healthDistribution': '應用健康度分佈',
  'pages.projects.overview.resourceQuota': '專案資源配額使用率',
  'pages.projects.overview.resourceUsage': '資源利用率看板',
  'pages.projects.overview.field.runningApps': '運行中應用',
  'pages.projects.overview.cpuUsed': 'CPU 配額',
  'pages.projects.overview.memoryUsed': '內存配額',
  'pages.projects.overview.storageUsed': '存儲空間',
  'pages.projects.overview.quickEntry': '常用快捷入口',
  'pages.projects.overview.quickEntry.appList': '應用列表',
  'pages.projects.overview.quickEntry.market': '從模板市場安裝',
  'pages.projects.overview.quickEntry.inviteMember': '邀請成員',
  'pages.projects.overview.serviceHealthRate': '服務健康率',
  'pages.projects.overview.cpuQuota': 'CPU 算力配額',
  'pages.projects.overview.recentActivity': '近期操作動態',
  'pages.projects.overview.noActivity': '暫無最近操作記錄',

  // 市場
  'pages.projects.market.title': '應用與中間件市場',
  'pages.projects.market.subtitle': '開箱即用的第一方套件與標準中間件',
  'pages.projects.market.category.all': '全部模板',
  'pages.projects.market.category.workvista': 'WorkVista 官方套件',
  'pages.projects.market.category.middleware': '數據與中間件',
  'pages.projects.market.installAction': '一鍵安裝到專案',
  'pages.projects.market.installModalTitle': '安裝應用模板: {name}',
  'pages.projects.market.installSuccess': '模板已成功實例化並部署到當前專案',

  // 數據庫
  'pages.projects.databases.title': '數據庫與數據存儲實例',
  'pages.projects.databases.create': '新建數據庫實例',
  'pages.projects.databases.column.name': '實例名稱',
  'pages.projects.databases.column.engine': '引擎與版本',
  'pages.projects.databases.column.status': '狀態',
  'pages.projects.databases.column.host': '連接端點',
  'pages.projects.databases.column.storage': '存儲使用率',
  'pages.projects.databases.connString': '連接字符串',
  'pages.projects.databases.action.restart': '重啟實例',
  'pages.projects.databases.action.stop': '停止實例',
  'pages.projects.databases.createSuccess': '數據庫實例創建成功',
  'pages.projects.databases.actionSuccess': '數據庫操作已下發',

  // 存儲
  'pages.projects.storage.title': '對象存儲 (S3 兼容)',
  'pages.projects.storage.create': '新建存儲桶',
  'pages.projects.storage.column.bucket': '存儲桶名稱',
  'pages.projects.storage.column.endpoint': 'S3 Endpoint',
  'pages.projects.storage.column.quota': '已用空間 / 配額',
  'pages.projects.storage.column.files': '對象數',
  'pages.projects.storage.column.acl': '訪問控制',
  'pages.projects.storage.column.keys': '訪問憑證 (AK/SK)',
  'pages.projects.storage.createSuccess': '存儲桶創建成功',
  'pages.projects.storage.fileList': '文件預覽',

  // 應用
  'pages.projects.app.column.status': '狀態',
  'pages.projects.app.column.category': '類型',
  'pages.projects.app.column.repoUrl': '代碼倉庫',
  'pages.projects.app.column.version': '運行版本',
  'pages.projects.app.column.endpoints': '訪問地址',
  'pages.projects.app.create.title': '創建應用',
  'pages.projects.app.create.success': '應用創建成功',
  'pages.projects.app.form.name.placeholder': '請輸入應用名稱',
  'pages.projects.app.form.category': '應用類型',
  'pages.projects.app.form.repoMode': '代碼倉庫來源',
  'pages.projects.app.form.repoMode.create': '自動創建代碼倉庫',
  'pages.projects.app.form.repoMode.bind': '綁定已有代碼倉庫',
  'pages.projects.app.form.repoMode.create.hint':
    '將按珊瑚蟲應用標準自動創建代碼倉庫，無需手動填寫地址',
  'pages.projects.app.form.repoUrl': '代碼倉庫地址',
  'pages.projects.app.form.repoUrl.invalid': '請輸入合法的 Git 倉庫地址',
  'pages.projects.app.overview': '應用概覽',
  'pages.projects.appStatus.draft': '待部署',
  'pages.projects.appStatus.deploying': '部署中',
  'pages.projects.appStatus.running': '運行中',
  'pages.projects.appStatus.stopped': '已停止',
  'pages.projects.appStatus.failed': '異常',

  // 應用詳情 Tab
  'pages.projects.app.tab.overview': '概覽與 Pod 拓撲',
  'pages.projects.app.tab.logs': '實時容器日誌',
  'pages.projects.app.tab.deploy': '部署配置',
  'pages.projects.app.tab.history': '版本發布與回滾',
  'pages.projects.app.pod.title': 'Pod 實例健康度與資源利用',
  'pages.projects.app.pod.name': 'Pod 名稱',
  'pages.projects.app.pod.node': '運行節點',
  'pages.projects.app.pod.ip': 'Pod IP',
  'pages.projects.app.pod.restarts': '重啟次數',
  'pages.projects.app.pod.cpu': 'CPU 佔用',
  'pages.projects.app.pod.memory': '內存佔用',
  'pages.projects.app.logs.autoScroll': '自動滾屏',
  'pages.projects.app.logs.clear': '清空輸出',
  'pages.projects.app.logs.download': '下載日誌',
  'pages.projects.app.logs.search': '搜索日誌關鍵字...',
  'pages.projects.app.history.version': '版本號',
  'pages.projects.app.history.commit': 'Git 提交',
  'pages.projects.app.history.operator': '部署人',
  'pages.projects.app.history.time': '部署時間',
  'pages.projects.app.history.rollback': '一鍵回滾到該版本',
  'pages.projects.app.history.rollbackConfirm':
    '確認回滾到版本 {version} 嗎？當前應用將重新編排容器鏡像。',
  'pages.projects.app.history.rollbackSuccess': '已成功觸發回滾',

  'pages.projects.app.column.branch': '代碼分支',
  'pages.projects.app.column.image': '容器鏡像地址',
  'pages.projects.app.column.imagePrefix': '鏡像: {image}',
  'pages.projects.app.column.repoOrImage': '源碼 / 鏡像',
  'pages.projects.app.form.description': '應用描述',
  'pages.projects.app.list.category.all': '全部',
  'pages.projects.app.list.healthRate': '服務健康率',
  'pages.projects.app.repoMode.image': '容器鏡像部署',
  'pages.projects.appCategory.agent': 'AI Agent',
  'pages.projects.appCategory.backend': '後端服務',
  'pages.projects.appCategory.frontend': 'Web 前端',
  'pages.projects.appCategory.fullstack': '全棧應用',

  'pages.projects.app.wizard.title.template': '新建應用 / 開發環境',
  'pages.projects.app.wizard.title.config': '配置與啟動應用',
  'pages.projects.app.wizard.step1':
    '第 1 步：選擇開箱即用的開發模板或自定義鏡像',
  'pages.projects.app.wizard.step2': '第 2 步：配置應用參數與代碼存儲模式',
  'pages.projects.app.wizard.createSuccess':
    '應用「{name}」創建成功！已拉起雲端實例',
  'pages.projects.app.wizard.customImage': '從空白應用 / 自定義容器鏡像創建',
  'pages.projects.app.wizard.emptyCategory': '暫無匹配的開發模板',
  'pages.projects.app.wizard.loadFailed': '模板加載失敗，請重試',
  'pages.projects.app.wizard.retry': '重試',
  'pages.projects.app.wizard.search.placeholder':
    '搜索開發模板、語言、框架或技術棧...',
  'pages.projects.app.wizard.category.all': '全部模板',
  'pages.projects.app.wizard.category.official': '官方腳手架',
  'pages.projects.app.wizard.category.featured': '官方精選',
  'pages.projects.app.wizard.category.frontend': '前端 / 全棧',
  'pages.projects.app.wizard.category.backend': '後端 / 微服務',
  'pages.projects.app.wizard.category.language': '語言環境',
  'pages.projects.app.wizard.category.framework': '應用框架',
  'pages.projects.app.wizard.category.ai': 'AI & 數據',
  'pages.projects.app.wizard.hero.tip':
    '選擇開箱即用的開發腳手架快速初始化 Git 倉庫與 CI/CD 流水線，或使用自定義容器鏡像直接部署。',
  'pages.projects.app.wizard.featuredSection': '官方精選推薦',
  'pages.projects.app.wizard.allSection': '模板資產庫',
  'pages.projects.app.wizard.customImageCard.title': '自定義容器鏡像部署',
  'pages.projects.app.wizard.customImageCard.desc':
    '從 Harbor、Docker Hub 或私有 Registry 拉取已有容器鏡像直接部署，無需初始化代碼腳手架。',
  'pages.projects.app.wizard.customImageCard.badge': '純鏡像 / 無 Git 依賴',
  'pages.projects.app.wizard.customImageCard.action': '直接配置鏡像',
  'pages.projects.app.wizard.card.author': 'By: {author}',
  'pages.projects.app.wizard.card.use': '選用此模板',
  'pages.projects.app.wizard.card.details': '架構詳情',
  'pages.projects.app.wizard.card.featuredBadge': '精選',
  'pages.projects.app.wizard.card.officialBadge': '官方認證',
  'pages.projects.app.wizard.card.specs': '默認規格',
  'pages.projects.app.wizard.card.port': '端口',
  'pages.projects.app.wizard.filter.allTags': '全部技術棧',
  'pages.projects.app.wizard.filter.reset': '重置篩選條件',
  'pages.projects.app.wizard.drawer.title': '模板架構詳情與配置規範',
  'pages.projects.app.wizard.drawer.scaffoldFeatures': '開箱即用特性',
  'pages.projects.app.wizard.drawer.versions': '版本與鏡像矩陣',
  'pages.projects.app.wizard.drawer.defaultResources': '基準資源配置',
  'pages.projects.app.wizard.drawer.gitScaffold': '代碼倉庫初始化策略',
  'pages.projects.app.wizard.drawer.useThis': '選用此模板並配置應用',
  'pages.projects.app.wizard.empty.tip':
    '沒有找到匹配的開發模板，您可以嘗試更換關鍵詞，或直接使用自定義容器鏡像部署。',

  'pages.projects.app.wizard.sourceMode.createGit.title':
    '自動創建託管 Git 倉庫',
  'pages.projects.app.wizard.sourceMode.createGit.badge': '推薦 / 自動初始化',
  'pages.projects.app.wizard.sourceMode.createGit.desc':
    '在珊瑚雲內建 Git 服務中自動初始化代碼倉庫，注入所選模板腳手架並自動關聯 CI/CD 構建流水線。',
  'pages.projects.app.wizard.sourceMode.bindGit.title': '綁定已有 Git 倉庫',
  'pages.projects.app.wizard.sourceMode.bindGit.badge': '外部代碼庫',
  'pages.projects.app.wizard.sourceMode.bindGit.desc':
    '關聯已有 GitHub / GitLab / Gitee 倉庫地址與分支，每次代碼 Push 自動觸發編譯與滾動發布。',
  'pages.projects.app.wizard.sourceMode.image.title':
    '容器鏡像直接部署 (無需 Git)',
  'pages.projects.app.wizard.sourceMode.image.badge': '純鏡像 / 無 Git 依賴',
  'pages.projects.app.wizard.sourceMode.image.desc':
    '直接通過 Docker 鏡像 (如官方鏡像或私有 Registry 產物) 啟動實例，完全無需創建或綁定 Git 倉庫。',

  'pages.projects.app.wizard.config.customImageApp': '自定義容器鏡像應用',
  'pages.projects.app.wizard.config.customImageDesc':
    '直接指定任意 Docker 鏡像運行並掛載存儲與網絡',
  'pages.projects.app.wizard.config.changeTemplate': '更換模板',
  'pages.projects.app.wizard.config.basicInfo': '基本信息',
  'pages.projects.app.wizard.config.name.required': '請輸入應用名稱',
  'pages.projects.app.wizard.config.name.pattern':
    '僅支持小寫字母、數字與中劃線',
  'pages.projects.app.wizard.config.name.maxLength': '不能超過50個字符',
  'pages.projects.app.wizard.config.name.extra':
    '作為服務名與 DNS 前綴，創建後不支持修改',
  'pages.projects.app.wizard.config.name.placeholder': '例如: my-node-service',
  'pages.projects.app.wizard.config.description.placeholder':
    '簡要說明此應用的用途與業務場景',
  'pages.projects.app.wizard.config.category.required': '請選擇應用分類',
  'pages.projects.app.wizard.config.sourceStrategy': '代碼與構建策略',
  'pages.projects.app.wizard.config.sourceStrategy.hint':
    '支持平台自動創建倉庫、綁定已有 Git 或純鏡像直跑',
  'pages.projects.app.wizard.config.repoName': '託管倉庫名稱',
  'pages.projects.app.wizard.config.repoName.extra':
    '系統將在內建 Git 服務中自動初始化該代碼倉庫並推送模板腳手架與 CI/CD 流水線',
  'pages.projects.app.wizard.config.repoUrl.required':
    '請輸入已有的 Git 倉庫地址',
  'pages.projects.app.wizard.config.branch': '部署分支',
  'pages.projects.app.wizard.config.image': '容器鏡像地址 (Image:Tag)',
  'pages.projects.app.wizard.config.image.required': '請輸入容器鏡像地址',
  'pages.projects.app.wizard.config.image.extra':
    '直接拉取已有容器鏡像啟動服務，完全不需要創建或關聯任何 Git 倉庫',
  'pages.projects.app.wizard.config.runtime': '運行時與網絡配置',
  'pages.projects.app.wizard.config.cpu': 'CPU 配額',
  'pages.projects.app.wizard.config.memory': '內存配額',
  'pages.projects.app.wizard.config.port': '服務端口',
  'pages.projects.app.wizard.config.port.required': '請填寫端口',
  'pages.projects.app.wizard.config.publicDomain': '公網訪問路由',
  'pages.projects.app.wizard.config.on': '開啟',
  'pages.projects.app.wizard.config.off': '關閉',
  'pages.projects.app.wizard.config.domainPreview': '公網訪問域名預覽：',
  'pages.projects.app.wizard.config.advanced': '高級選項 (環境變量 & 啟動參數)',
  'pages.projects.app.wizard.config.customCommand':
    '自定義啟動命令 (Command & Args)',
  'pages.projects.app.wizard.config.customCommand.extra':
    '若留空則使用模板鏡像默認的 Entrypoint',
  'pages.projects.app.wizard.config.storage': '持久卷存儲容量 (GB)',
  'pages.projects.app.wizard.config.storage.extra':
    '將持久化掛載到應用的 /data 目錄',
  'pages.projects.app.wizard.config.backToTemplate': '返回模板選擇',
  'pages.projects.app.wizard.config.submit': '立即創建並運行',
  'pages.projects.app.wizard.config.descriptionFromTemplate':
    '基於 {name} ({version}) 開發模板構建',

  // 成員
  'pages.projects.member.column.name': '姓名',
  'pages.projects.member.column.email': '郵箱',
  'pages.projects.member.column.role': '角色',
  'pages.projects.member.column.joinedAt': '加入時間',
  'pages.projects.member.add.title': '添加成員',
  'pages.projects.member.add.success': '成員添加成功',
  'pages.projects.member.form.selectCandidate': '從組織/租戶成員中選取',
  'pages.projects.member.form.selectCandidate.placeholder':
    '搜索姓名、用戶名或郵箱快速選擇',
  'pages.projects.member.form.member': '成員標識',
  'pages.projects.member.form.member.required': '請輸入或選擇成員標識/UUID',
  'pages.projects.member.form.member.placeholder':
    '請輸入成員 memberUuid / 姓名',
  'pages.projects.member.form.name': '成員姓名',
  'pages.projects.member.form.name.placeholder':
    '例如：張三（選填，默認自動從身份庫同步）',
  'pages.projects.member.form.email': '成員郵箱',
  'pages.projects.member.form.email.placeholder':
    '例如：zhangsan@company.com（選填）',
  'pages.projects.member.form.role': '專案角色',
  'pages.projects.member.role.admin': '專案管理員',
  'pages.projects.member.role.member': '專案成員',
  'pages.projects.member.remove.confirm': '確認移除該成員嗎？',
  'pages.projects.member.remove.success': '成員已移除',
  'pages.projects.member.permission': '應用細粒度權限',
  'pages.projects.permission.title': '{name} 的應用權限矩陣',
  'pages.projects.permission.column.app': '應用名稱',
  'pages.projects.permission.column.visible': '可見 (Visible)',
  'pages.projects.permission.column.deploy': '可部署 (Deploy)',
  'pages.projects.permission.column.manage': '可管理 (Manage)',
  'pages.projects.permission.save.success': '權限已保存',
  'pages.projects.permission.quickPreset': '快捷預設: ',
  'pages.projects.permission.presetViewer': '全部唯讀',
  'pages.projects.permission.presetDeveloper': '全部開發者',
  'pages.projects.permission.presetAdmin': '全部管理員',

  // 審計日誌
  'pages.projects.audit.noPermission': '僅專案管理員可查看審計日誌',
  'pages.projects.audit.column.operator': '操作人',
  'pages.projects.audit.column.action': '操作類型',
  'pages.projects.audit.column.target': '操作對象',
  'pages.projects.audit.column.detail': '詳情',
  'pages.projects.audit.column.createdAt': '操作時間',
  'pages.projects.audit.action.projectCreate': '創建專案',
  'pages.projects.audit.action.projectUpdate': '更新專案',
  'pages.projects.audit.action.projectDelete': '刪除專案',
  'pages.projects.audit.action.appCreate': '創建應用',
  'pages.projects.audit.action.appDeploy': '發布部署',
  'pages.projects.audit.action.appLifecycle': '狀態變更',
  'pages.projects.audit.action.appDelete': '刪除應用',
  'pages.projects.audit.action.memberAdd': '添加成員',
  'pages.projects.audit.action.memberRemove': '移除成員',
  'pages.projects.audit.action.memberPermissionsUpdate': '權限配置',
  'pages.projects.audit.action.databaseCreate': '創建數據庫',
  'pages.projects.audit.action.databaseAction': '數據庫操作',
  'pages.projects.audit.action.marketInstall': '安裝市場模板',

  // 部署配置
  'pages.projects.deploy.title': '部署配置',
  'pages.projects.deploy.noPermission': '僅專案管理員可配置部署',
  'pages.projects.deploy.source': '部署來源',
  'pages.projects.deploy.source.image': '鏡像部署',
  'pages.projects.deploy.source.repoBuild': '代碼倉庫構建',
  'pages.projects.deploy.branch': '構建分支',
  'pages.projects.deploy.image': '鏡像地址',
  'pages.projects.deploy.resource': '資源規格',
  'pages.projects.deploy.cpu': 'CPU',
  'pages.projects.deploy.memory': '內存',
  'pages.projects.deploy.replicas': '副本數',
  'pages.projects.deploy.network': '網絡配置',
  'pages.projects.deploy.port': '容器端口',
  'pages.projects.deploy.port.exposePublic': '公網訪問 (Ingress)',
  'pages.projects.deploy.port.add': '添加端口',
  'pages.projects.deploy.envVars': '環境變量與 Secret',
  'pages.projects.deploy.envVars.add': '添加環境變量',
  'pages.projects.deploy.storage': '存儲卷掛載',
  'pages.projects.deploy.storage.add': '添加存儲卷',
  'pages.projects.deploy.healthCheck': '健康檢查探針',
  'pages.projects.deploy.healthCheck.enable': '啟用健康檢查',
  'pages.projects.deploy.healthCheck.path': '檢查路徑',
  'pages.projects.deploy.healthCheck.port': '檢查端口',
  'pages.projects.deploy.submit': '保存並立即發布',
  'pages.projects.deploy.success': '部署已提交',

  // 生命週期
  'pages.projects.lifecycle.start': '啟動',
  'pages.projects.lifecycle.stop': '停止',
  'pages.projects.lifecycle.stop.confirm': '確認停止該應用嗎？',
  'pages.projects.lifecycle.restart': '重啟',
  'pages.projects.lifecycle.rollback': '回滾',
  'pages.projects.lifecycle.rollback.placeholder': '請選擇回滾的歷史版本',
  'pages.projects.lifecycle.delete': '刪除',
  'pages.projects.lifecycle.delete.confirm': '確認刪除該應用嗎？此操作不可恢復',
  'pages.projects.lifecycle.success': '操作已提交',

  // 專案設置與配額
  'pages.projects.settings.basicInfo': '專案空間基本信息',
  'pages.projects.settings.saveChanges': '保存修改',
  'pages.projects.settings.saveSuccess': '專案空間基本信息更新成功',
  'pages.projects.settings.quotaSuccess':
    '配額擴容申請已提交（CPU: {cpu} Core, 內存: {memory} GiB），已自動生效',
  'pages.projects.settings.field.uuid': '專案空間唯一標識 (UUID / Namespace)',
  'pages.projects.settings.quotaManagement': '算力與資源配額管理',
  'pages.projects.settings.applyQuota': '申請擴容配額',
  'pages.projects.settings.quotaProtectionTitle': '配額保護機制已啟用',
  'pages.projects.settings.quotaProtectionDesc':
    '當空間下所有運行中的微服務與 AI Agent 的 CPU/內存總和觸達配額上限時，新應用部署將被安全攔截，防止集群節點因超售引發 OOM。',
  'pages.projects.settings.cpuLimit': 'CPU 算力硬限制 (Core)',
  'pages.projects.settings.allocatedUsage': '已分配利用率: {used} Core',
  'pages.projects.settings.memoryLimit': '內存容量上限 (GiB)',
  'pages.projects.settings.allocatedUsageGiB': '已分配利用率: {used} GiB',
  'pages.projects.settings.storageLimit': '持久存儲上限 (GiB)',
  'pages.projects.settings.mountedPvc': '已掛載 PVC: {used} GiB',
  'pages.projects.settings.dangerZone': '空間生命週期管理（危險區）',
  'pages.projects.settings.archive.title': '歸檔此專案空間',
  'pages.projects.settings.archive.hint':
    '凍結運行中的所有實例，停止計算資源計費，數據安全保留',
  'pages.projects.settings.archive.button': '歸檔空間',
  'pages.projects.settings.archive.confirm': '確認歸檔該專案空間？',
  'pages.projects.settings.archive.content':
    '歸檔後，該空間下的所有微服務與 Agent 將進入凍結狀態，停止算力計費，配置與持久卷數據將完整保留。',
  'pages.projects.settings.archive.ok': '確認歸檔',
  'pages.projects.settings.archive.success': '專案空間「{name}」已成功歸檔',
  'pages.projects.settings.destroy.title': '徹底銷毀此專案空間',
  'pages.projects.settings.destroy.hint':
    '立即刪除 Kubernetes Namespace、清理所有容器與存儲卷，不可恢復',
  'pages.projects.settings.destroy.button': '銷毀空間',
  'pages.projects.settings.destroy.confirm': '高危操作：確認銷毀該專案空間？',
  'pages.projects.settings.destroy.content':
    '此操作不可逆！銷毀後，該空間下的所有容器 Pod、存儲卷 PVC 以及團隊權限關聯將徹底釋放。',
  'pages.projects.settings.destroy.ok': '強制銷毀',
  'pages.projects.settings.destroy.success': '專案空間「{name}」已徹底銷毀釋放',
  'pages.projects.settings.expandModal.title': '申請專案算力配額擴容',
  'pages.projects.settings.expandModal.ok': '確認擴容',
  'pages.projects.settings.expandModal.cpu': '目標 CPU 算力上限 (Core)',
  'pages.projects.settings.expandModal.memory': '目標內存上限 (GiB)',
  'pages.projects.settings.expandModal.storage': '目標持久卷存儲上限 (GiB)',

  // 平臺管理（佔位）
  'pages.management.placeholder.fields': '規劃中的字段/能力：',
  'pages.management.identities.description':
    '統一管理企業內所有工作主體的身份庫，覆蓋自然人員工、外部人員、Agent、數字員工、系統賬號，專案內添加成員將從這裏選取，而不是各專案各自維護一份成員數據。',
  'pages.management.identityType.human': '自然人員工',
  'pages.management.identityType.external': '外部人員',
  'pages.management.identityType.agent': 'Agent',
  'pages.management.identityType.digital': '數字員工',
  'pages.management.identityType.system': '系統賬號',
  'pages.management.roles.description':
    '獨立於專案之外的全局角色與權限矩陣，按角色定義對應用/數據/接口/Agent 四個維度的訪問範圍，取代專案內簡單的“管理員/成員”兩檔角色。',
  'pages.management.role.globalAdmin': '全局管理員',
  'pages.management.role.workspaceOwner': '工作空間負責人',
  'pages.management.role.developer': '開發者',
  'pages.management.role.viewer': '唯讀',
  'pages.management.role.agentCaller': 'Agent 調用者',
  'pages.management.auditLog.description':
    '跨專案的平臺級操作審計，可按專案篩選，僅面向具備審計權限的角色開放。與專案詳情頁內的審計日誌是否合併，待後續確定。',
  'pages.management.auditLog.field.operator': '操作人',
  'pages.management.auditLog.field.project': '所屬專案',
  'pages.management.auditLog.field.action': '操作類型',
  'pages.management.auditLog.field.result': '執行結果',
  'pages.management.auditLog.field.time': '操作時間',
  'pages.management.clusters.description':
    '面向全局管理員的 Kubernetes 集羣與基礎設施運維入口，對應“運維與可觀測”能力，涵蓋節點、資源、健康檢查、告警等。',
  'pages.management.clusters.field.nodes': '節點管理',
  'pages.management.clusters.field.resource': '資源監控',
  'pages.management.clusters.field.health': '健康檢查',
  'pages.management.clusters.field.alerts': '異常告警',
  'pages.auditLog.title': '全景安全與 AI 審計大盤',
  'pages.auditLog.description':
    '集中記錄平臺全生命週期的系統關鍵操作、數據敏感訪問，以及 AI Agent 大模型調用與 Token 消耗鏈條，滿足企業級合規與追溯要求。',
  'pages.auditLog.action.refresh': '刷新',
  'pages.auditLog.stats.totalOperations': '今日全域操作',
  'pages.auditLog.stats.sensitiveOperations': '敏感與高危操作',
  'pages.auditLog.stats.aiCalls': 'AI Agent 即時調用',
  'pages.auditLog.stats.totalTokens': '今日 Token 消耗總量',
  'pages.auditLog.stats.timesSuffix': '次',
  'pages.auditLog.stats.tenThousand': '萬',
  'pages.auditLog.filter.all': '全部審計',
  'pages.auditLog.filter.operation': '系統操作審計',
  'pages.auditLog.filter.aiCall': 'AI Token 審計',
  'pages.auditLog.filter.dataAccess': '數據訪問留痕',
  'pages.auditLog.filter.keywordPlaceholder': '搜尋操作人/Agent/動作/目標...',
  'pages.auditLog.filter.search': '查詢',
  'pages.auditLog.filter.startDate': '開始時間',
  'pages.auditLog.filter.endDate': '結束時間',
  'pages.auditLog.table.operator': '操作主體',
  'pages.auditLog.table.type': '審計類型',
  'pages.auditLog.table.actionTarget': '動作與目標',
  'pages.auditLog.table.project': '所屬專案',
  'pages.auditLog.table.metrics': 'AI / 性能指標',
  'pages.auditLog.table.status': '狀態',
  'pages.auditLog.table.time': '操作時間',
  'pages.auditLog.table.detail': '詳情',
  'pages.auditLog.table.totalCount': '共 {total} 條記錄',
  'pages.auditLog.badge.operation': '系統操作',
  'pages.auditLog.badge.aiCall': 'AI Token 審計',
  'pages.auditLog.badge.dataAccess': '數據訪問',
  'pages.auditLog.status.success': '成功',
  'pages.auditLog.status.warning': '告警',
  'pages.auditLog.status.failed': '失敗',
  'pages.auditLog.operatorType.agent': '智能體',
  'pages.auditLog.operatorType.system': '系統',
  'pages.auditLog.operatorType.human': '使用者',
  'pages.auditLog.drawer.title': '審計日誌追蹤詳情',
  'pages.auditLog.drawer.basicContext': '基礎上下文',
  'pages.auditLog.drawer.id': '審計 ID:',
  'pages.auditLog.drawer.operator': '操作主體:',
  'pages.auditLog.drawer.project': '所屬專案:',
  'pages.auditLog.drawer.platformGlobal': '平臺全域',
  'pages.auditLog.drawer.clientIp': '客戶端 IP:',
  'pages.auditLog.drawer.occurredAt': '發生時間:',
  'pages.auditLog.drawer.actionDetail': '操作與詳細說明',
  'pages.auditLog.drawer.action': '動作名稱:',
  'pages.auditLog.drawer.target': '影響目標:',
  'pages.auditLog.drawer.detail': '執行詳情:',
  'pages.auditLog.drawer.aiDetail': 'AI Runtime 調度明細',
  'pages.auditLog.drawer.model': '基座大模型:',
  'pages.auditLog.drawer.promptTokens': 'Prompt Tokens:',
  'pages.auditLog.drawer.completionTokens': 'Completion Tokens:',
  'pages.auditLog.drawer.totalTokens': '總計 Token:',
  'pages.auditLog.drawer.latency': '端到端延遲:',
  'pages.auditLog.metric.prompt': 'Prompt',
  'pages.auditLog.metric.completion': 'Completion',
  'pages.auditLog.metric.latency': '耗時',
  'pages.auditLog.metric.ip': 'IP',
  'pages.platformTenants.title': '租戶管理',
  'pages.platformUsers.title': '使用者管理',
  'pages.platformUsers.resetPassword': '重設密碼',
  'pages.platformUsers.resetPasswordTitle': '重設「{name}」的密碼',
  'pages.platformUsers.resetPasswordNotice':
    '重設後舊密碼立即失效，請透過安全管道將新密碼告知使用者。',
  'pages.platformUsers.newPassword': '新密碼',
  'pages.platformUsers.newPasswordRequired': '請輸入新密碼',
  'pages.platformUsers.newPasswordLength': '密碼長度為 6-64 位',
  'pages.platformUsers.generatePassword': '隨機產生',
  'pages.platformUsers.copyPassword': '複製密碼',
  'pages.platformUsers.passwordCopied': '已複製到剪貼簿',
  'pages.platformUsers.passwordCopyFailed': '複製失敗，請手動複製',
  'pages.platformUsers.resetPasswordSuccess': '密碼已重設',
  'pages.platformUsers.avatar': '頭像',
  'pages.platformUsers.avatarUpload': '上傳頭像',
  'pages.platformUsers.avatarHint': '支援 PNG、JPG、WEBP，不超過 5MB',
  'pages.platformUsers.uploadFailed': '上傳失敗，請重試',
  'pages.platformUsers.save': '儲存',
  'pages.platformUsers.reset': '重設',
  'pages.platformUsers.saveSuccess': '個人資料已儲存',
  'pages.platformUsers.website': '個人網站',
  'pages.platformUsers.websiteInvalid': '請輸入有效的網址',
  'pages.platformUsers.country': '國家',
  'pages.platformUsers.province': '省份',
  'pages.platformUsers.city': '城市',
  'pages.platformUsers.postalCode': '郵遞區號',
  'pages.platformUsers.identifierClearForbidden':
    '該使用者沒有使用者名稱，手機號和信箱不能同時為空，否則將無法登入',
  'pages.platformUsers.usernameImmutableHint': '使用者名稱建立後不可修改',
  'pages.platformUsers.tab.basic': '基本資訊',
  'pages.platformUsers.tab.tenants': '所屬租戶',
  'pages.platformUsers.tab.identities': '第三方帳號',
  'pages.platformUsers.tab.loginHistory': '登入紀錄',
  'pages.platformUsers.userNotFound': '使用者不存在或已被刪除',
  'pages.platformUsers.sectionAccount': '帳號資訊',
  'pages.platformUsers.sectionProfile': '個人資料',
  'pages.platformUsers.verified': '已驗證',
  'pages.platformUsers.unverified': '未驗證',
  'pages.platformUsers.registerSourceLabel': '註冊方式',
  'pages.platformUsers.registerSource.adminCreated': '管理員建立',
  'pages.platformUsers.registerSource.basic:phone': '手機號註冊',
  'pages.platformUsers.registerSource.basic:email': '信箱註冊',
  'pages.platformUsers.registerSource.basic:username': '使用者名稱註冊',
  'pages.platformUsers.signedUp': '註冊時間',
  'pages.platformUsers.validity': '帳號有效期',
  'pages.platformUsers.perpetual': '永久有效',
  'pages.platformUsers.loginsCount': '登入次數',
  'pages.platformUsers.lastLogin': '最後登入時間',
  'pages.platformUsers.lastIp': '最後登入 IP',
  'pages.platformUsers.genderLabel': '性別',
  'pages.platformUsers.gender.M': '男',
  'pages.platformUsers.gender.F': '女',
  'pages.platformUsers.gender.U': '未知',
  'pages.platformUsers.birthdate': '生日',
  'pages.platformUsers.company': '公司',
  'pages.platformUsers.address': '詳細地址',
  'pages.platformUsers.tenantName': '租戶名稱',
  'pages.platformUsers.tenantCode': '租戶編碼',
  'pages.platformUsers.departments': '所屬部門',
  'pages.platformUsers.departmentPath': '部門路徑',
  'pages.platformUsers.noDepartments': '未加入任何部門',
  'pages.platformUsers.noIdentities': '未綁定第三方帳號',
  'pages.platformUsers.idpName': '身分來源',
  'pages.platformUsers.idpCategory': '身分來源類型',
  'pages.platformUsers.idpCategory.enterprise': '企業身分來源',
  'pages.platformUsers.idpCategory.social': '社群身分來源',
  'pages.platformUsers.idpDisplayName': '第三方帳號名稱',
  'pages.platformUsers.idpUserId': '第三方使用者識別碼',
  'pages.platformUsers.bindTime': '綁定時間',
  'pages.platformUsers.noLoginHistory': '暫無登入紀錄',
  'pages.platformUsers.loginTime': '登入時間',
  'pages.platformUsers.loginApp': '登入應用',
  'pages.platformUsers.loginEvent': '事件',
  'pages.platformUsers.loginResult': '結果',
  'pages.platformUsers.loginIp': 'IP 位址',
  'pages.platformUsers.loginLocation': '登入地點',
  'pages.platformUsers.loginClient': '瀏覽器 / 系統 / 裝置',
  'pages.platformUsers.keywordLabel': '關鍵詞',
  'pages.platformUsers.searchPlaceholder': '搜尋使用者名稱、姓名、手機號或信箱',
  'pages.platformUsers.user': '使用者',
  'pages.platformUsers.userId': '使用者 ID',
  'pages.platformUsers.username': '使用者名稱',
  'pages.platformUsers.name': '姓名',
  'pages.platformUsers.namePlaceholder': '真實姓名',
  'pages.platformUsers.nickname': '暱稱',
  'pages.platformUsers.phone': '手機號',
  'pages.platformUsers.email': '信箱',
  'pages.platformUsers.password': '初始密碼',
  'pages.platformUsers.statusLabel': '狀態',
  'pages.platformUsers.status.Activated': '正常',
  'pages.platformUsers.status.Suspended': '已停用',
  'pages.platformUsers.status.Deleted': '已刪除',
  'pages.platformUsers.createdAt': '建立時間',
  'pages.platformUsers.updatedAt': '更新時間',
  'pages.platformUsers.actions': '操作',
  'pages.platformUsers.edit': '編輯',
  'pages.platformUsers.enable': '啟用',
  'pages.platformUsers.disable': '停用',
  'pages.platformUsers.delete': '刪除',
  'pages.platformUsers.createUser': '新增使用者',
  'pages.platformUsers.detailTitle': '使用者詳情',
  'pages.platformUsers.tenants': '所屬租戶',
  'pages.platformUsers.noTenants': '尚未加入任何租戶',
  'pages.platformUsers.usernamePlaceholder': '用於帳號密碼登入',
  'pages.platformUsers.phonePlaceholder': '用於驗證碼登入',
  'pages.platformUsers.emailPlaceholder': 'name@example.com',
  'pages.platformUsers.passwordHint':
    '可不填，使用者之後可透過驗證碼登入或重設密碼',
  'pages.platformUsers.emailInvalid': '信箱格式不正確',
  'pages.platformUsers.identifierRequired':
    '使用者名稱、手機號、信箱至少填寫一項',
  'pages.platformUsers.createSuccess': '使用者已建立',
  'pages.platformUsers.enableSuccess': '已啟用',
  'pages.platformUsers.disableSuccess': '已停用',
  'pages.platformUsers.deleteSuccess': '使用者已刪除',
  'pages.platformUsers.enableConfirm': '確定啟用該使用者？',
  'pages.platformUsers.disableConfirm':
    '停用後該使用者將無法登入任何租戶，確定停用？',
  'pages.platformUsers.batchEnable': '批次啟用',
  'pages.platformUsers.batchDisable': '批次停用',
  'pages.platformUsers.clearSelection': '取消選擇',
  'pages.platformUsers.batchEnableConfirm': '確定啟用選中的 {count} 個使用者？',
  'pages.platformUsers.batchDisableConfirm':
    '停用後這 {count} 個使用者將無法登入，確定停用？',
  'pages.platformUsers.deleteConfirmTitle': '確定刪除使用者「{name}」？',
  'pages.platformUsers.deleteConfirmContent':
    '刪除後該帳號將從使用者池移除，並失去所有租戶的成員身分，此操作無法復原。',
  'pages.platformTenants.searchPlaceholder': '搜尋租戶名稱或 UUID',
  'pages.platformTenants.keywordLabel': '關鍵字',
  'pages.platformTenants.name': '租戶名稱',
  'pages.platformTenants.uuid': '租戶 UUID',
  'pages.platformTenants.code': '租戶編碼',
  'pages.platformTenants.memberCount': '成員數量',
  'pages.platformTenants.createdAt': '建立時間',
  'pages.platformTenants.actions': '操作',
  'pages.platformTenants.viewDetail': '查看詳情',
  'pages.platformTenants.backToList': '返回租戶列表',
  'pages.platformTenants.tabMembers': '成員',
  'pages.platformTenants.tabDepartments': '組織',
  'pages.platformTenants.keywordSearch': '搜尋姓名、手機、郵箱或工號',
  'pages.platformTenants.memberName': '姓名',
  'pages.platformTenants.memberPhone': '手機號',
  'pages.platformTenants.memberEmail': '郵箱',
  'pages.platformTenants.memberJobNumber': '工號',
  'pages.platformTenants.memberPosition': '職位',
  'pages.platformTenants.memberStatus': '狀態',
  'pages.platformTenants.statusEnabled': '正常',
  'pages.platformTenants.statusDisabled': '停用',
  'pages.platformTenants.memberRole': '角色身分',
  'pages.platformTenants.admin': '管理員',
  'pages.platformTenants.regularMember': '普通成員',
  'pages.platformTenants.leader': '部門主管',
  'pages.platformTenants.drawerTitle': '成員畫像詳情',
  'pages.platformTenants.joinedAt': '加入時間',
  'pages.platformTenants.username': '使用者名稱',
  'pages.platformTenants.department': '所屬部門',
  'pages.platformTenants.includeChildren': '包含子部門成員',
  'pages.platformTenants.selectDepartmentPrompt': '請選擇左側部門查看成員',
  'pages.platformTenants.noDepartments': '暫無部門資料',
  'pages.platformTenants.totalCount': '共 {total} 項',
  'pages.platformTenants.tabApps': '應用',
  'pages.platformTenants.description': '簡介',
  'pages.platformTenants.logo': 'Logo',
  'pages.platformTenants.logoUpload': '上傳 Logo',
  'pages.platformTenants.logoHint': '支援 png/jpg/svg/webp，不超過 5MB',
  'pages.platformTenants.nameRequired': '請輸入租戶名稱',
  'pages.platformTenants.saveSuccess': '租戶資訊已更新',
  'pages.platformTenants.saveFailed': '儲存失敗，請稍後再試',
  'pages.platformTenants.uploadFailed': 'Logo 上傳失敗',
  'pages.platformTenants.appName': '應用名稱',
  'pages.platformTenants.appId': '應用 ID',
  'pages.platformTenants.installSource': '開通來源',
  'pages.platformTenants.installSourcePackage': '方案',
  'pages.platformTenants.installSourceTenant': '單獨開通',
  'pages.platformTenants.noApps': '該租戶尚未開通應用',
  'pages.platformTenants.appsLoadFailed': '應用列表載入失敗',
  'pages.platformTenants.tabBasic': '基本資訊',
  'pages.platformTenants.save': '儲存',
  'pages.platformTenants.reset': '重設',
  'pages.platformTenants.updatedAt': '更新時間',
  'pages.platformTenants.profileCard': '基礎資料',
  'pages.platformTenants.infoCard': '租戶資訊',
  'pages.myTenants.title': '租戶設定',
  'pages.myTenants.member': '成員',
  'pages.myTenants.empty': '你尚未加入任何企業',
  'pages.myTenants.selectTenant': '未能確定目前租戶，請重新登入',
  'pages.platformTenants.loadCommercialConfigFailed': '載入商業設定失敗',
  'pages.platformTenants.loadCommercialStatusFailed': '載入租戶商業狀態失敗',
  'pages.platformTenants.grantSuccess': '授權已生效',
  'pages.platformTenants.grantFailed': '授權失敗',
  'pages.platformTenants.subscriptionType': '類型',
  'pages.platformTenants.status': '狀態',
  'pages.platformTenants.target': '對象',
  'pages.platformTenants.adminGift': '管理員贈送',
  'pages.platformTenants.startsAt': '開始時間',
  'pages.platformTenants.expiresAt': '到期時間',
  'pages.platformTenants.perpetual': '長期',
  'pages.platformTenants.purchaseParams': '購買參數',
  'pages.platformTenants.orderNo': '訂單號',
  'pages.platformTenants.orderDefaultPlan': '系統預設',
  'pages.platformTenants.orderMarketFree': '應用市場免費',
  'pages.platformTenants.appsCount': '{count} 個應用',
  'pages.platformTenants.featureCode': '權益碼',
  'pages.platformTenants.featureName': '權益名稱',
  'pages.platformTenants.featureType': '類型',
  'pages.platformTenants.finalValue': '最終值',
  'pages.platformTenants.sources': '來源',
  'pages.platformTenants.tenantCommercialStatus': '租戶商業狀態',
  'pages.platformTenants.adminGrant': '管理員授權',
  'pages.platformTenants.entitlementIntro':
    '這裡顯示租戶最終商業權益，業務系統應依據權益碼鑑權，而不是判斷方案名稱。',
  'pages.platformTenants.subscriptions': '訂閱',
  'pages.platformTenants.finalEntitlements': '最終權益',
  'pages.platformTenants.tabEntitlements': '權益',
  'pages.platformTenants.tabRoles': '角色',
  'pages.platformTenants.tabAudit': '稽核日誌',
  'pages.platformTenants.detailTitle': '租戶詳情',
  'pages.platformTenants.typePlan': '方案訂閱',
  'pages.platformTenants.typeAddon': '加購商品',
  'pages.platformTenants.typeManualGrant': '人工贈送',
  'pages.platformTenants.on': '開啟',
  'pages.platformTenants.off': '關閉',
  'pages.platformTenants.seatsUnit': '{count} 席位',
  'pages.platformTenants.quantityUnit': '{count} 份',
  'pages.platformTenants.monthsUnit': '{count} 個月',
  'pages.platformTenants.amountYuan': '{amount} 元',
  'pages.platformTenants.refresh': '重新整理',
  'pages.platformTenants.grantType': '授權類型',
  'pages.platformTenants.planVersion': '選擇方案版本',
  'pages.platformTenants.priceItem': '價格項',
  'pages.platformTenants.addonProduct': '加購商品',
  'pages.platformTenants.purchaseQuantity': '購買數量',
  'pages.platformTenants.targetFeature': '目標權益',
  'pages.platformTenants.switchState': '開關狀態',
  'pages.platformTenants.numericValue': '數值',
  'pages.platformTenants.applicationCodes': '應用代碼列表（每行一個）',
  'pages.platformTenants.seatCount': '席位數',
  'pages.platformTenants.months': '訂購月數',
  'pages.platformTenants.paidAmount': '實付金額（元）',
  'pages.myTenants.detailTitle': '租戶設定',
};
